// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2QoNk","inputWrap":"styles_inputWrap__3D2on","input":"styles_input__FgIPa"};